import { makeAutoObservable } from "mobx";
import { RArray } from "../collections";
import { P24_CHANNEL_ID } from "./P24";
/**
 * A parent container for all information about the restaurant (menu, timezone, etc...)
 */
export class Restaurant {
    constructor(params) {
        this.id = params.id;
        this.menu = params.menu;
        this.menuConsumer = params.menuConsumer;
        this.orderingPolicy = params.orderingPolicy;
        this.minOrderValue = params.minOrderValue;
        this.fulfillmentMethods = params.fulfillmentMethods;
        this.paymentMethods = params.paymentMethods;
        this._paymentChannels = params.paymentChannels;
        this.blikLevel0Enabled = params.blikLevel0Enabled;
        makeAutoObservable(this);
    }
    get paymentChannels() {
        if (!this.paymentMethods.includes("Online")) {
            return RArray.empty();
        }
        let channels = this._paymentChannels;
        if (this.menuConsumer === "QrWaiter") {
            channels = channels.filtered((channel) => {
                return !(channel.id.tag === "P24Channel" &&
                    channel.id.contents === P24_CHANNEL_ID.PAYPO);
            });
        }
        if (!this.blikLevel0Enabled) {
            channels = channels.filtered((channel) => {
                return !(channel.id.tag === "P24Channel" &&
                    channel.id.contents === P24_CHANNEL_ID.BLIK_LEVEL_0);
            });
        }
        if (this.blikLevel0Enabled) {
            channels = channels.filtered((channel) => {
                return !(channel.id.tag === "P24Channel" &&
                    channel.id.contents === P24_CHANNEL_ID.BLIK);
            });
        }
        return channels;
    }
}
